export default {
	'no-specialty-materials-to-show': 'No specialty materials found for this month.',
}